import { ComponentProps } from 'react';
import { SearchAlertToggle } from '../SearchAlertToggle/SearchAlertToggle';
import { SearchAlertTile } from './SearchAlertTile';

type Props = ComponentProps<typeof SearchAlertToggle>;

export const SearchAlertTileNoResults = (props: Props) => {
  return <SearchAlertTile {...props} inactiveVariant={'no-results'} />;
};
